import { createCallable } from "./_sdk/client";

//////// AI ////////
import type { handlers as aiHandlers } from "./ai/handlers";
const ai = createCallable<typeof aiHandlers>("ai");
////////////////////

//////// REFINER SIGNATURE ////////
import type { handlers as refinerSignatureHandlers } from "./refiner/handlers";
const refiner = createCallable<typeof refinerSignatureHandlers>("refiner");
////////////////////

//////// SEARCH ////////
import type { handlers as searchHandlers } from "./search/handlers";
const search = createCallable<typeof searchHandlers>("search");
////////////////////

//////// WORKSPACES BILLING ////////
import type { handlers as workspacesBillingHandlers } from "./workspacesBilling/handlers";
const workspacesBilling = createCallable<typeof workspacesBillingHandlers>("workspacesBilling");
////////////////////

//////// ZENDESK ////////
import type { handlers as zendeskHandlers } from "./zendesk/handlers";
const zendesk = createCallable<typeof zendeskHandlers>("zendesk");
////////////////////

//////// EMAIL ////////
import type { handlers as emailHandlers } from "./email/handlers";
const email = createCallable<typeof emailHandlers>("email");
////////////////////

//////// NOTIFICATION EVENTS ////////
import type { handlers as notificationEventsHandlers } from "./notificationEvents/handlers";
const notificationEvents = createCallable<typeof notificationEventsHandlers>("notificationevents");
////////////////////

export {
    ai,
    refiner,
    search,
    workspacesBilling,
    zendesk,
    email,
    notificationEvents
};
